// extracted by mini-css-extract-plugin
export default {"top-button":"_w8bw4a","topButton":"_w8bw4a","bottom-button":"_1uno12c","bottomButton":"_1uno12c"};